// extracted by mini-css-extract-plugin
export default {"root":"FamiliesAndPetsSection_root__DX7cw","tag":"FamiliesAndPetsSection_tag__DZNuf"};